import React, { useState, useEffect } from "react";
import { AddFileDialog } from "../shared/addFileDialog";
import { mmRecordService } from '../../services/api/mmRecord.service';
import { filesService } from '../../services/api/files.service';  
import { alertService } from '../../services/helpers/alert.service';
import { utils } from "../../services/helpers/utils";

export const MMRecordFiles = (props) => {

    const [fileList, setFileList] = useState([]);
    const [visibleFileDialog, setVisibleFileDialog] = React.useState(false);
    const rol = sessionStorage.getItem("rol");

    useEffect(() => {
        if (props && props.idFisa) {
            mmRecordService.getFiles({ recordId: props.idFisa })
                .then(response => {
                    if (response) {
                        //setFileList(response);
                        updateLists(response);
                    }
                });
        }
    }, [props.refresh]);

    const addFile = (file) => {
        var newFile = [...fileList, file]
        updateLists(newFile);
    }

    function handleDelete(index) {
        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi acest fisier?"
            , () => {
                var list = [...fileList];
                list.splice(index, 1);
                updateLists(list);
            }
            , () => { return; }
        );
    }

    const updateLists = (list) =>{
        setFileList(list);
        props.setFisiere(list);
        if (props.setIsModified) {
            props.setIsModified(true);
        }
    }

    const toggleFileDialog = () => {
        setVisibleFileDialog(!visibleFileDialog);
    };

    const handleView = (item) => {
        // Daca are downloadId inseamna ca fisierul a fost salvat in baza de date
        if (item.hasOwnProperty("downloadId")) {
            filesService.getFile({ queryString: item.downloadId, partener: props.partener })
                .then(response => {
                    if (response) {
                        utils.viewResponse(response, item.nume)
                    }
                })


        }
        else {
            utils.downloadFilebyName(item.fisier, item.nume);
        }
        return;
    }

   
    const handleDownload = (item) => {
        if (item.hasOwnProperty("downloadId")) {
            filesService.downloadFile({ queryString: item.downloadId, partener: props.partener });
        }
        else {
            utils.downloadFilebyName(item.fisier, item.nume);
        }
    }

    return (
        <>
            <fieldset>
                <legend className="pt20 pb5">Fisiere</legend>
                <table className="tbl tbladd mt5" name="lista_fisiere" width="100%">
                    <thead>
                        <tr>
                            <th>Nume fisier</th>
                            <th>Descriere</th>
                            <th>Dimensiune</th>
                            {props.finalizare != 1 && rol != 2 && <th width="50">Sterge</th>}
                            <th width="50">Vizualizeaza</th>
                            <th width="50">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fileList.map((file, index) => (
                            <tr key={index}>
                                <td name="nume_fisier"> {file.nume} </td>
                                <td name="descriere"  > {file.descriere}</td>
                                <td name="dimensiune" > {file.dimensiune}</td>
                                {props.finalizare != 1 && rol !=2 &&
                                    <td>
                                         <span className="icon sterge center" name="fisier_del" onClick={() => handleDelete(index)}> </span>
                                    </td>
                                }
                                <td>
                                    <span className="icon deschide center" name="fisier_view" onClick={ () => handleView(file) }></span>
                                </td>
                                <td>
                                    <span className="icon download center" name="fisier_down" onClick={() => handleDownload(file)}> </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {!props.finalizare && rol !=2 && (
                    <button
                        name="adauga_fisier"
                        className="btn mt10"
                        onClick={toggleFileDialog}
                    >Adauga fisier</button>
                )}
                <p className="paragraf red mt15">Campurile marcate cu * sunt obligatorii.</p>
            </fieldset>

            {visibleFileDialog && <AddFileDialog toggleDialog={toggleFileDialog} addFile={addFile} />}
        </>
    );
}